import * as types from '../../../../constants/ActionNameConstants';

// Vendor list
export const vendorsRequest = (payload) => ({
  type: types.GET_VENDORS_LIST_REQUEST,
  payload,
});

export const vendorsSuccess = (payload) => ({
  type: types.GET_VENDORS_LIST_SUCCESS,
  payload,
});

export const vendorsFailure = (error) => ({
  type: types.GET_VENDORS_LIST_FAILED,
  error,
});

// Vendor filter list
export const vendorsFilterRequest = (params) => ({
  type: types.GET_VENDORS_FILTER_LIST_REQUEST,
  data: params,
});

export const vendorsFilterSuccess = (payload) => ({
  type: types.GET_VENDORS_FILTER_LIST_SUCCESS,
  payload,
});

export const vendorsFilterFailure = (error) => ({
  type: types.GET_VENDORS_FILTER_LIST_FAILED,
  error,
});
